<ng-container *ngComponentOutlet="component ?? null"></ng-container>
<ng-container *ngTemplateOutlet="template ?? null"></ng-container>
